import { Box1 } from '../../general_assets/containers'
import { PopupForm } from '../../general_assets/popup_form.js'
import { useEffect, useState } from "react"
import rest, { JSONRequest } from '../../utils/rest.js'
import './Banking.css'

export function BankLists({data, refresh}) {
    const [getSelected, setSelected] = useState("Savings")
    // For forms
    const [getValue, setValue] = useState({})
    const [getType, setType] = useState("date")// for savings forms
    const [getOpen, setOpen] = useState("none")
    const [getTriggerAnimatrion, setTriggerAnimation] = useState("")

    function RenderList() {
        switch(getSelected) {
            case 'Savings':
                return <Savers data={data}/>

            case "Bills":
                return <Bills data={data}/>

            case "Logs":
                return <Logs />
        }
    }

    return (
        <div className="bank_lists">
            <Box1 title={getSelected}>
                <RenderList/>
            </Box1>
            <div className='bank_lists_buttons'>
                <button onClick={() => {setSelected("Savings")}} disabled={getSelected == "Savings"}> Savings </button>
                <button onClick={() => {setSelected("Bills")}} disabled={getSelected == "Bills"}> Bills </button>
                <button onClick={() => {setSelected("Logs")}} disabled={getSelected == "Logs"}> Logs </button>

                {/* ADD BUTTON */}
                {getSelected == "Savings" || getSelected == "Bills" ? <button className='bank_add_button' onClick={() => {
                    if (getSelected == "Savings") {
                        setOpen("create_saver")
                    } else {
                        setOpen("create_bill")
                    }
                }}> + </button> : null}

                {getOpen != "none" ? <PopupForm 
                                        getValue={getValue} 
                                        setValue={setValue} 
                                        setCancel={() => {setOpen("none")}} 
                                        setClosed={() => {getOpen == "create_saver" ? SendNewSaving() : SendNewBill()}}
                                        title={getOpen == "create_saver" ? getType : "Add Bill"}> 
                                        {getOpen == "create_saver" ? SavingsCreationContent(getType) : BillsCreationContent()}
                                    </PopupForm> : null}
            </div>
        </div>
    )

    // ==============================[ BILLS ]==============================
    function BillPeriod(weeks) {
        const periodLookup = {
            1: "weekly",
            4: "monthly",
            13: "quarterly",
            26: "half yearly",
            52: "yearly"
        };

        return periodLookup[weeks] || `${weeks} weeks`;
    }

    function SendNewBill() {
        let period = getValue.period != undefined ? getValue.period : 1

        var bill = {
            name: getValue.name,
            perweek: (getValue.cost / period).toFixed(2),
            text: `$${getValue.cost} ${BillPeriod(period)}`
        }
        
        rest.JSONRequest("bank/bill/create", "POST", bill, {}).then(() => {
            refresh(1000); //refresh 2 seconds after get succeeds or fails
        })

        //Clear getValue and close form
        setOpen("none")
        setValue({})
    }

    function DeleteBill(bill_to_delete) {
        setTriggerAnimation(bill_to_delete);

        rest.JSONRequest("bank/bill/delete", "DELETE", {name: bill_to_delete}, {}).then((response) => {
            refresh(2000); //refresh 2 seconds after get succeeds or fails
        })
    }

    function BillsCreationContent() {
        return (<>
            <input type="text" placeholder="Name" name="name" key="name"/>
            <input type="number" placeholder="cost" name="cost" key="cost" />
            <select name="period">
                <option value="1">Weekly</option>
                <option value="4">Monthly</option>
                <option value="13">Quarterly</option>
                <option value="26">Half Yearly</option>
                <option value="52">Yearly</option>
            </select>
        </>)
    }

    function Bills({data}) {
        var getData = data.bills

        console.log(data)

        // Check if getData is null or undefined
        if (getData == null) {
            return (<p className='text'> No Bills Found </p>)
        }

        return (<>
            {Object.keys(getData).map((ele) => {
                return (<div className={`saver ${getTriggerAnimatrion == ele ? "saver_deleting" : ""}`}>
                    <div className='circle'>
                        <h1 style={{fontSize: "2.5rem"}}>{getData[ele].icon}</h1>
                    </div>
                    <div className='v-stack'>
                        <div className='h-stack'>
                            <h1> {ele} </h1> 
                            <h1 className='stop_wrap'> ${getData[ele].perweek} </h1>
                            <h2> /week</h2>
                        </div>
                        <h3> {getData[ele].text} </h3>  {/*<h3> {getData[ele].bottom_text} </h3>*/}
                    </div>
                    <div className='v-stack buttons'>
                        <h3 style={{textAlign: "right"}}>{getData[ele].priority}</h3>
                        <button onClick={() => {DeleteBill(ele)}}> 🗑️ </button>
                    </div>
                </div>)
            })}
        </>)
    }

    // ==============================[ SAVINGS ]==============================
    function SendNewSaving() {
        var newSaving = {...getValue, type: getType }

        rest.JSONRequest("bank/savings/create", "POST", newSaving, {}).then(() => {
            refresh(1000); //refresh 2 seconds after get succeeds or fails
        })

        //Clear getValue and close form
        setOpen("none")
        setValue({})
    }
    
    function SendDeleteSaver(saver_to_delete) {
        setTriggerAnimation(saver_to_delete);

        rest.JSONRequest("bank/savings/delete", "DELETE", {name: saver_to_delete}, {}).then((response) => {
            refresh(2000); //refresh 2 seconds after get succeeds or fails
        })
    }

    function SavingsCreationContent(type) {

        const PreContent = <>
            <div className='h-stack'>
                <button type="button" onClick={() => {setType("date")}} style={{flexGrow: 1}}> date </button>
                <button type="button" onClick={() => {setType("Weekly")}} style={{flexGrow: 1}}> Weekly </button>
                <button type="button" onClick={() => {setType("Bucket")}} style={{flexGrow: 1}}> Bucket </button>
            </div>
            
            <input type="text" placeholder="Name" name="name" key="name"/>
            <input type="number" placeholder="Goal" name="goal" key="goal" />
            <input type="number" placeholder="Saved" name="saved" key="saved"/>
            <input type="number" placeholder="Priority" name="priority" key="priority"/>
        </>

        switch (type) {
            case "date": // date Type
                return (
                    <>
                        {PreContent}
                        <input type="date" placeholder="Date" name="date" />
                    </>
                );

            case "Weekly": // Weekly Type
                return (
                    <>
                        {PreContent}
                        <input type="number" placeholder="Per Week" name="perweek" />
                    </>
                );

            default: // Bucket type
                return (
                    <>
                        {PreContent}
                        <p style={{width: "100%", textAlign: "center", margin: "9px"}}> ♫♪.ılılıll|̲̅̅●̲̅̅|̲̅̅=̲̅̅|̲̅̅●̲̅̅|llılılı.♫♪ </p>
                    </>
                );
        }
    }

    function Savers({data}) {
        
        const getClipPath = (angle) => {
            const radians = (angle - 90) * (Math.PI / 180);
            const x = 50 + 50 * Math.cos(radians);
            const y = 50 + 50 * Math.sin(radians);
            return `M 50 50 L 50 0 A 50 50 0 ${angle > 180 ? 1 : 0} 1 ${x} ${y} Z`;
        };

        var getData = data.savings

        // Check if getData is null or undefined
        if (getData == null) {
            return (<p className='text'> No Savings Found </p>)
        }

        return (<>
            {Object.keys(getData).map((ele) => {
                const progress = (parseFloat(getData[ele].saved) / parseFloat(getData[ele].goal));
                return (<div className={`saver ${getTriggerAnimatrion == ele ? "saver_deleting" : ""}`}>
                    <div className='circle'>
                        <svg width="5rem" height="5rem" viewBox="0 0 100 100">
                            <defs>
                                <clipPath id={`clip${ele.replaceAll(" ", "_")}`}>
                                    <path d={getClipPath(Math.round(360 * progress))} fill="white" />
                                </clipPath>
                            </defs>
                            <circle cx="50" cy="50" r="40" stroke="white" strokeWidth="3" fill="none" />
                            <circle cx="50" cy="50" r="40" stroke="white" strokeWidth="10" fill="none" clipPath={`url(#clip${ele.replaceAll(" ", "_")})`} />
                            <text x="50" y="58" fontSize="22" fill="white" textAnchor="middle">{Math.round(progress * 100)}%</text>
                        </svg>
                    </div>
                    <div className='v-stack'>
                        <div className='h-stack'>
                            <h1> {ele} ${getData[ele].saved} </h1>
                            <h2> /${getData[ele].goal}</h2>
                        </div>
                        <h3> {BankBottomText(getData[ele])} </h3>
                    </div>
                    <div className='v-stack buttons'>
                        <h3 style={{textAlign: "right"}}>{getData[ele].priority}</h3>
                        <button onClick={() => {SendDeleteSaver(ele)}}> 🗑️ </button>
                    </div>
                </div>)
            })}
        </>)
    }

    function BankBottomText(saver) {
        switch(saver.type.toLowerCase()) {
            case "date":
                let splitDate = saver.date.split('-')
                
                if(splitDate.length < 3) { return `[E] ${saver.date}` }

                let date = `${splitDate[2]}/${splitDate[1]}/${splitDate[0]}`
                let days = Math.ceil(Math.abs((new Date(splitDate)).getTime() - Date.now()) / (1000 * 3600 * 24));

                if (days > 365) {
                    let years = Math.round((days / 365.0)*100)/100
                    return `${date} (${years} years away)`
                }

                if (days > 30) {
                    let months = Math.round((days / 30.436875)*100)/100
                    return `${date} (${months} months away)`
                }

                return `${date} (${days} days away)`

            case "bucket":
                return "Bucket Saver"

            case "weekly":
                return `Constant $${saver.perweek} per week`

            default:
                return "Unknown Type"
        }
    }

    // =========================[ LOGS ]=========================

    function Logs() {
        const [getLogs, setLogs] = useState("Connecting...")

        useEffect(() => {
            GetConsoleLoop();
            const interval = setInterval(() => {
                GetConsoleLoop();
            }, 5000);

            return () => clearInterval(interval)
        }, [])

        //TODO: add some sort of mutex lock
        function GetConsoleLoop(){
            rest.JSONRequest('bank/logs', 'GET', {}, {}).then((response) => {
                setLogs(response.status == 200 ? response.data.logs : 'Failed to get logs');
            })
        }

        return (<p className='text'>{getLogs}</p>)
    }
}